import { createTheme } from '@mui/material';
import { focusOutline } from '@barracuda/shared/styles/focus';
import { theme as sharedTheme } from '@barracuda/shared/styles/theme';

export { $fontOpenSans, mediaQuery } from '@barracuda/shared/styles/theme';

const interactiveFocusSelector =
  'a:focus-visible, button:focus-visible, input:focus-visible, select:focus-visible, textarea:focus-visible, [role="button"]:focus-visible, [role="link"]:focus-visible, [tabindex]:not([tabindex="-1"]):focus-visible';

// Theme is not imported straight from shared. This easily allow exclusively extend theme in single package.
// ignoring TS2590: Expression produces a union type that is too complex to represent.
// @ts-ignore
export const theme = createTheme(sharedTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        [interactiveFocusSelector]: focusOutline
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&:focus-visible': focusOutline
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          '&:focus-visible': focusOutline
        }
      }
    }
  }
});
